import React, { useEffect, useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { subRouteMapping } from "../constant/subRoutes";
import routes from "../routes";
import { Link, useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import checkcircle from "../assests/images/check-circle.png";
import { categoryServices } from "../services/categoryServices";
import AlertComponent from "../views/alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import _ from "lodash";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import CreateIcon from "@mui/icons-material/Create";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Switch } from "@mui/material";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
  createData("Ice cream sandwich", 237, 9.0, 37, 4.3),
  createData("Eclair", 262, 16.0, 24, 6.0),
  createData("Cupcake", 305, 3.7, 67, 4.3),
  createData("Gingerbread", 356, 16.0, 49, 3.9),
];
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const blockListArr = [
  {
    blockName: "Category",
    label: "Category",
    blockUrlName: "zone",
    isInput: true,
    isListAdd: true,
    isListEdit: true,
    isListRemove: true,
    list: [],
    headList: [],
  },
  {
    blockName: "Sub-Category",
    label: "Sub-Category",
    blockUrlName: "region",
    isInput: false,
    isListAdd: true,
    isListEdit: true,
    isListRemove: true,
    list: [],
    headList: [],
  },
];

const blockListDepartArr = [
  {
    blockName: "Department",
    label: "Department",
    blockUrlName: "department",
    isInput: true,
    isListAdd: true,
    isListEdit: true,
    isListRemove: true,
    list: [],
    headList: [],
  },
  {
    blockName: "Role",
    label: "Role",
    blockUrlName: "role",
    isInput: false,
    isListAdd: true,
    isListEdit: true,
    isListRemove: true,
    isUpdateRole: true,
    list: [],
    headList: [],
  },
];

function DynamicNestedTable(props) {
  let subModulesArr = props?.data?.role?.modulePermissions?.subModules;
  return (
    <>
      <div class="text-centers pt-3 ">
        <TableContainer className="mb-3" component={Paper}>
          <Table aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell className="table_react_listing_controlpanel_block">
                  Sub Module
                </StyledTableCell>
                <StyledTableCell className="table_react_listing_controlpanel_block">
                  Feature
                </StyledTableCell>
                <StyledTableCell className="table_react_listing_controlpanel_block">
                  Toggle
                </StyledTableCell>
                <StyledTableCell className="table_react_listing_controlpanel_block">
                  Create
                </StyledTableCell>
                <StyledTableCell className="table_react_listing_controlpanel_block">
                  Read
                </StyledTableCell>
                <StyledTableCell className="table_react_listing_controlpanel_block">
                  Update
                </StyledTableCell>
                <StyledTableCell className="table_react_listing_controlpanel_block">
                  Delete
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody className="lets_panel_rolelist_block">
              {subModulesArr?.map((innerArray, outerIndex) =>
                innerArray?.features.map((ele, innerIndex) => (
                  <StyledTableRow>
                    <StyledTableCell className="cell_tabel_controlpanel_listing_blocksers">
                      {innerIndex == 0 ? innerArray?.name : ""}
                    </StyledTableCell>

                    <StyledTableCell className="cell_tabel_controlpanel_listing_blocksers">
                      {ele?.name}
                    </StyledTableCell>

                    <StyledTableCell className="cell_tabel_controlpanel_listing_blocksers">
                      <label>No</label>
                      <Switch
                        checked={ele?.permissions?.master}
                        onChange={(e) =>
                          props?.handlePermissionToggle(
                            "master",
                            e.target.checked,
                            outerIndex,
                            innerIndex
                          )
                        }
                      />
                      <label>Yes</label>
                    </StyledTableCell>

                    <StyledTableCell className="cell_tabel_controlpanel_listing_blocksers">
                      <label>No</label>
                      <Switch
                        checked={ele?.permissions?.create}
                        onChange={(e) =>
                          props?.handlePermissionToggle(
                            "create",
                            ele?.permissions?.create,
                            outerIndex,
                            innerIndex
                          )
                        }
                      />
                      <label>Yes</label>
                    </StyledTableCell>
                    <StyledTableCell className="cell_tabel_controlpanel_listing_blocksers">
                      <label>No</label>
                      <Switch
                        checked={ele?.permissions?.read}
                        onChange={(e) =>
                          props?.handlePermissionToggle(
                            "read",
                            ele?.permissions?.read,
                            outerIndex,
                            innerIndex
                          )
                        }
                      />
                      <label>Yes</label>
                    </StyledTableCell>
                    <StyledTableCell className="cell_tabel_controlpanel_listing_blocksers">
                      <label>No</label>
                      <Switch
                        checked={ele?.permissions?.update}
                        onChange={(e) =>
                          props?.handlePermissionToggle(
                            "update",
                            ele?.permissions?.update,
                            outerIndex,
                            innerIndex
                          )
                        }
                      />
                      <label>Yes</label>
                    </StyledTableCell>
                    <StyledTableCell className="cell_tabel_controlpanel_listing_blocksers">
                      <label>No</label>
                      <Switch
                        checked={ele?.permissions?.delete}
                        onChange={(e) =>
                          props?.handlePermissionToggle(
                            "delete",
                            ele?.permissions?.delete,
                            outerIndex,
                            innerIndex
                          )
                        }
                      />
                      <label>Yes</label>
                    </StyledTableCell>
                  </StyledTableRow>

                  // <tr key={`${outerIndex}-${innerIndex}`}>
                  //   <td>{`${outerIndex}, ${innerIndex}`}</td>
                  //   <td>{value}</td>
                  // </tr>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
}

function CategoryManagement() {
  const [isLoading, setIsLoading] = useState(false);
  const [categoryOpen, setOpencategoryOpen] = React.useState(false);
  const [openpermissionmanagement, setOpenPermissionManagement] =
    React.useState(false);
  const [blockList, setBlockList] = React.useState(blockListArr);
  const [blockListDepart, setBlockListDepart] =
    React.useState(blockListDepartArr);

  const [addModalOpenData, setAddModalOpenData] = React.useState({});
  const [deleteObj, setDeleteObj] = React.useState({});
  const [successfullycategoryOpen, setOpensuccessfullycategoryOpeneState] =
    React.useState(false);
  const [subcategoryOpen, setOpensubcategoryOpen] = React.useState(false);
  const [successfullysubcategoryOpen, setOpensuccessfullysubcategoryOpen] =
    React.useState(false);
  const [departmentsetopen, setdepartmentsetopen] = React.useState(false);
  const [successfullydepartmentsetopen, setsuccessfullydepartmentsetopen] =
    React.useState(false);
  const [rolesetopen, setrolesetopen] = React.useState(false);
  const [deleteiconopen, setdeleteiconopen] = React.useState(false);
  const [addSelectValue, setAddSelectValue] = React.useState("null");
  const [addSelectModule, setAddSelectModule] = React.useState("ONBOARDING");
  const [addTextValue, setAddTextValue] = React.useState("");
  const [selectedRoleId, setSelectedRoleId] = React.useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [rolePermissionObj, setRolePermissionObj] = useState({});
  const [roleAssignArr, setRoleAssignArr] = useState([]);
  const [configSubRoute, setConfigSubRoute] = useState([]);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isEdited, setIsEdited] = useState(false);
  const [opencreateprojectsuccessfully, setOpenCreateProjectSuccessfully] =
    useState(false);
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });
  const location = useLocation();

  const handleAddModalOpen = (data, ele, i, secName) => {
    if (data == true) {
      let obj = {
        currentIdx: i,
        currentBlockName: ele?.label,
        secName: secName,
      };
      setAddModalOpenData(obj);
      setOpensubcategoryOpen(true);
    } else {
      setAddTextValue("");
      setAddSelectValue("null");
      setAddModalOpenData({});
      setOpensubcategoryOpen(false);
    }
  };

  const openDeleteModal = (e, ele, i, item, j, blockName, secName) => {
    let obj = { ele, i, item, j, blockName, secName };
    setDeleteObj(obj);
    setdeleteiconopen(true);
  };

  const openUpdatePermissionModal = (
    e,
    ele,
    i,
    item,
    j,
    blockName,
    secName
  ) => {
    let blockListDepartInitial = _.cloneDeep(blockListDepart);
    // let obj = { ele, i, item, j, blockName, secName };

    let selectedDepartFilterData = blockListDepartInitial[0]?.list?.filter(
      (filterEle) => filterEle?.isChecked == true
    );
    let selectedDepartId = selectedDepartFilterData[0]._id;
    setAddTextValue(item?.name);
    setAddSelectValue(selectedDepartId);
    setSelectedRoleId(item?._id);

    setAddSelectModule("ONBOARDING");
    getRolePermissionData(item?._id, `?moduleName=ONBOARDING`);
    // setDeleteObj(obj);
    // getRolePermissionData(resObj?._id, `?moduleName=ONBOARDING`);
    // setdeleteiconopen(true);
  };

  const closeDeleteModal = () => {
    setDeleteObj({});
    setdeleteiconopen(false);
  };

  const confirmDeleteModal = () => {
    setIsLoading(true);
    let deleteObjInitial = { ...deleteObj };
    let blockListInitial = _.cloneDeep(blockList);
    let blockListDepartInitial = _.cloneDeep(blockListDepart);

    let objPromise = null;

    switch (deleteObjInitial?.blockName) {
      case "Category":
        objPromise = categoryServices.deleteCategory(
          deleteObjInitial?.item?._id
        );
        blockListInitial[deleteObjInitial?.i].list.splice(
          deleteObjInitial?.j,
          1
        );
        break;

      case "Sub-Category":
        objPromise = categoryServices.deleteSubCategory(
          deleteObjInitial?.item?._id
        );
        blockListInitial[deleteObjInitial?.i].list.splice(
          deleteObjInitial?.j,
          1
        );
        // blockListInitial[deleteObjInitial?.i-1].list[deleteObjInitial?.j].splice(deleteObjInitial?.j, 1);
        break;

      case "Department":
        objPromise = categoryServices.deleteDepartment(
          deleteObjInitial?.item?._id
        );
        blockListDepartInitial[deleteObjInitial?.i].list.splice(
          deleteObjInitial?.j,
          1
        );

        break;

      case "Role":
        objPromise = categoryServices.deleteRole(deleteObjInitial?.item?._id);
        blockListDepartInitial[deleteObjInitial?.i].list.splice(
          deleteObjInitial?.j,
          1
        );
        // blockListInitial[deleteObjInitial?.i-1].list[deleteObjInitial?.j].splice(deleteObjInitial?.j, 1);
        break;

      default:
        break;
    }

    objPromise
      .then((res) => {
        if (res.data.success === true) {
          setBlockList(blockListInitial);
          setBlockListDepart(blockListDepartInitial);
          closeDeleteModal();
          openAlert(true, "success", `${res.data?.message}`);
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally(() => {
        // Cleanup or loading state changes
        setIsLoading(false);
      });
    // setdeleteiconopen(true);
  };

  const handleClose = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };

  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };

  const onAddSelectChange = (e) => {
    setAddSelectValue(e.target.value);
  };

  const onAddTextChange = (e) => {
    setAddTextValue(e.target.value);
  };

  const addSubmit = () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    setIsLoading(true);
    if (addModalOpenData?.secName == "Category") {
      let blockListInitial = _.cloneDeep(blockList);

      if (addModalOpenData?.currentIdx == 0) {
        let obj = {
          categoryName: addTextValue,
        };
        categoryServices
          .createtCategoryManagement(obj)
          .then((res) => {
            if (res.data.success === true) {
              let resObj = res.data.data;
              resObj.label = resObj?.categoryName;
              blockListInitial[0].list.push(resObj);
              setBlockList(blockListInitial);
              setOpensubcategoryOpen(false);
              setAddTextValue("");
              setAddSelectValue("null");
              openAlert(true, "success", `${res.data?.message}`);
            }
          })
          .catch(function (error) {
            openAlert(true, "error", `${error?.response?.data?.message}`);
          })
          .finally(() => {
            // Cleanup or loading state changes
            setIsLoading(false);
            setIsSubmitting(false);
          });
      }

      if (addModalOpenData?.currentIdx > 0) {
        let obj = {
          subCategoryName: addTextValue,
        };
        categoryServices
          .createSubCategory(obj, addSelectValue)
          .then((res) => {
            if (res.data.success === true) {
              let resObj = res.data.data;
              resObj.label = resObj?.subCategoryName;

              for (
                let index = 0;
                index <
                blockListInitial[addModalOpenData?.currentIdx - 1].list.length;
                index++
              ) {
                if (
                  blockListInitial[addModalOpenData?.currentIdx - 1].list[index]
                    ._id == addSelectValue
                ) {
                  blockListInitial[addModalOpenData?.currentIdx - 1].list[
                    index
                  ].subcategories.push(resObj);
                  if (
                    blockListInitial[addModalOpenData?.currentIdx - 1].list[
                      index
                    ].isChecked == true
                  ) {
                    blockListInitial[addModalOpenData?.currentIdx].list.push(
                      resObj
                    );
                  }
                }
              }

              setBlockList(blockListInitial);
              setOpensubcategoryOpen(false);
              setAddTextValue("");
              setAddSelectValue("null");
              openAlert(true, "success", `${res.data?.message}`);
              // setOpensuccessfullysubcategoryOpen(true);
            }
          })
          .catch(function (error) {
            openAlert(true, "error", `${error?.response?.data?.message}`);
          })
          .finally(() => {
            // Cleanup or loading state changes
            setIsLoading(false);
            setIsSubmitting(false);
          });
      }
    }

    if (addModalOpenData?.secName == "Department") {
      let blockListInitial = _.cloneDeep(blockListDepart);

      if (addModalOpenData?.currentIdx == 0) {
        let obj = {
          departmentName: addTextValue,
        };
        categoryServices
          .createDepartment(obj)
          .then((res) => {
            if (res.data.success === true) {
              let resObj = res.data.data;
              resObj.label = resObj?.departmentName;
              blockListInitial[0].list.push(resObj);
              setBlockListDepart(blockListInitial);
              setOpensubcategoryOpen(false);
              setAddTextValue("");
              setAddSelectValue("null");
              openAlert(true, "success", `${res.data?.message}`);
            }
          })
          .catch(function (error) {
            openAlert(true, "error", `${error?.response?.data?.message}`);
          })
          .finally(() => {
            // Cleanup or loading state changes
            setIsLoading(false);
            setIsSubmitting(false);
          });
      }

      if (addModalOpenData?.currentIdx > 0) {
        let obj = {
          name: addTextValue,
          departmentId: addSelectValue,
        };
        categoryServices
          .createRole(obj)
          .then((res) => {
            if (res.data.success === true) {
              let resObj = res.data.data;
              resObj.label = resObj?.name;

              for (
                let index = 0;
                index <
                blockListInitial[addModalOpenData?.currentIdx - 1].list.length;
                index++
              ) {
                if (
                  blockListInitial[addModalOpenData?.currentIdx - 1].list[index]
                    ._id == addSelectValue
                ) {
                  blockListInitial[addModalOpenData?.currentIdx - 1].list[
                    index
                  ].roles.push(resObj);
                  if (
                    blockListInitial[addModalOpenData?.currentIdx - 1].list[
                      index
                    ].isChecked == true
                  ) {
                    blockListInitial[addModalOpenData?.currentIdx].list.push(
                      resObj
                    );
                  }
                }
              }

              setBlockListDepart(blockListInitial);
              setOpensubcategoryOpen(false);
              getRolePermissionData(resObj?._id, `?moduleName=ONBOARDING`);
              setAddTextValue("");
              setAddSelectValue("null");
              setSelectedRoleId(resObj?._id);
              openAlert(true, "success", `${res.data?.message}`);

              // setOpensuccessfullysubcategoryOpen(true);
            }
          })
          .catch(function (error) {
            openAlert(true, "error", `${error?.response?.data?.message}`);
          })
          .finally(() => {
            // Cleanup or loading state changes
            setIsLoading(false);
            setIsSubmitting(false);
          });
      }
    }
  };

  useEffect(() => {
    getCategoryData();
    getDepartmentData();
    setConfigSubRoute(subRouteMapping(routes, "CONFIGURATION"));
  }, []);

  const getRolePermissionData = (roleId, param) => {
    setIsLoading(true);
    categoryServices
      .getRolePermission(roleId, param)
      .then((res) => {
        if (res.data.success === true) {
          setOpenPermissionManagement(true);
          let arr = [];
          for (let obj in res?.data?.data?.assignedRoles) {
            arr.push({
              label: obj,
              value: `${res?.data?.data?.assignedRoles[obj]}`,
            });
          }
          setRoleAssignArr(arr);
          setRolePermissionObj(res.data.data);
        } else {
          // Handle error
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
        // Handle error
      })
      .finally(() => {
        // Cleanup or loading state changes
        setIsLoading(false);
      });
  };

  const getCategoryData = () => {
    let blockListInitial = [...blockList];
    categoryServices
      .getCategoryList()
      .then((res) => {
        if (res.data.success === true) {
          // Do something with the data
          let list = [...res.data.data];
          for (let i = 0; i < list.length; i++) {
            list[i].label = list[i].categoryName;
            for (let j = 0; j < list[i].subcategories.length; j++) {
              list[i].subcategories[j].label =
                list[i].subcategories[j].subCategoryName;
            }
          }
          blockListInitial[0].list = [...list];
          setBlockList(blockListInitial);
        } else {
          // Handle error
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
        // Handle error
      })
      .finally(() => {
        // Cleanup or loading state changes
      });
  };

  const getDepartmentData = () => {
    let blockListInitial = _.cloneDeep(blockListDepart);
    categoryServices
      .getdepartments()
      .then((res) => {
        if (res.data.success === true) {
          // Do something with the data
          let list = [...res.data.data];
          for (let i = 0; i < list.length; i++) {
            list[i].label = list[i].departmentName;
            for (let j = 0; j < list[i].roles.length; j++) {
              list[i].roles[j].label = list[i].roles[j].name;
            }
          }
          blockListInitial[0].list = [...list];
          setBlockListDepart(blockListInitial);
        } else {
          // Handle error
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
        // Handle error
      })
      .finally(() => {
        // Cleanup or loading state changes
      });
  };

  const onCheckChange = (e, [], ele, i, item, j, secName) => {
    if (secName == "Category") {
      let blockListInitial = _.cloneDeep(blockList);
      let { name, checked } = e.target;
      blockListInitial[i].list[j].isChecked = checked;
      for (let index = 0; index < blockListInitial[i].list.length; index++) {
        if (index == j) {
          continue;
        }
        blockListInitial[i].list[index].isChecked = false;
      }
      if (checked) {
        blockListInitial[1].list = [
          ...blockListInitial[i].list[j].subcategories,
        ];
      } else {
        blockListInitial[1].list = [];
      }
      setBlockList(blockListInitial);
    }

    if (secName == "Department") {
      let blockListInitial = _.cloneDeep(blockListDepart);
      let { name, checked } = e.target;
      blockListInitial[i].list[j].isChecked = checked;
      for (let index = 0; index < blockListInitial[i].list.length; index++) {
        if (index == j) {
          continue;
        }
        blockListInitial[i].list[index].isChecked = false;
      }
      if (checked) {
        blockListInitial[1].list = [...blockListInitial[i].list[j].roles];
      } else {
        blockListInitial[1].list = [];
      }
      setBlockListDepart(blockListInitial);
    }
  };

  // const handlePermissionToggle = (name, value, outerIndex, innerIndex) => {
  //   let rolePermissionObjInit = _.cloneDeep(rolePermissionObj); 
  //   rolePermissionObjInit.role.modulePermissions.subModules[
  //     outerIndex
  //   ].features[innerIndex].permissions[name] = !value;
  //   setRolePermissionObj(rolePermissionObjInit); 
  // };
  const handlePermissionToggle = (name, value, outerIndex, innerIndex) => {
    let rolePermissionObjInit = _.cloneDeep(rolePermissionObj);
    if (name === 'master') {
      rolePermissionObjInit.role.modulePermissions.subModules[outerIndex].features[innerIndex].permissions.create = value;
      rolePermissionObjInit.role.modulePermissions.subModules[outerIndex].features[innerIndex].permissions.read = value;
      rolePermissionObjInit.role.modulePermissions.subModules[outerIndex].features[innerIndex].permissions.update = value;
      rolePermissionObjInit.role.modulePermissions.subModules[outerIndex].features[innerIndex].permissions.delete = value;
    } else {
      rolePermissionObjInit.role.modulePermissions.subModules[outerIndex].features[innerIndex].permissions[name] = !value;

      if (name === 'create' && !value) {
        rolePermissionObjInit.role.modulePermissions.subModules[outerIndex].features[innerIndex].permissions.read = true;
      } else if (name === 'create' && value) {
        rolePermissionObjInit.role.modulePermissions.subModules[outerIndex].features[innerIndex].permissions.read = false;
      }
    }

    const { create, read, update, delete: del } = rolePermissionObjInit.role.modulePermissions.subModules[outerIndex].features[innerIndex].permissions;
    const isAllPermissionsTrue = create && read && update && del;

    rolePermissionObjInit.role.modulePermissions.subModules[outerIndex].features[innerIndex].permissions.master = isAllPermissionsTrue;
    setIsEdited(true);
    setRolePermissionObj(rolePermissionObjInit);
  };

  const handleClearToggles = () => {
    let rolePermissionObjInit = _.cloneDeep(rolePermissionObj);
    rolePermissionObjInit.role.modulePermissions.subModules.forEach((subModule) => {
      subModule.features.forEach((feature) => {
        feature.permissions.create = false;
        feature.permissions.read = false;
        feature.permissions.update = false;
        feature.permissions.delete = false;
        feature.permissions.master = false;
      });
    });
    setRolePermissionObj(rolePermissionObjInit);
  };

  const [changeCategoryModule, setChangeCategoryModule] = useState('');
  const changeModule = (e) => {
    if (isEdited) {
      setShowConfirmation(true);
      setChangeCategoryModule(e.target.value);
    } else {
      setIsEdited(false);
      let { value } = e.target;
      setAddSelectModule(value);
      getRolePermissionData(selectedRoleId, `?moduleName=${value}`);
    }
  };

  const submitRolePermission = () => {
    setIsLoading(true);
    let rolePermissionObjInit = _.cloneDeep(rolePermissionObj);

    let obj = {
      modulePermissions: [rolePermissionObjInit?.role?.modulePermissions],
    };
    categoryServices
      .updateRolePermission(selectedRoleId, obj)
      .then((res) => {
        openAlert(
          true,
          "success",
          `Role & Permission has been updated successfully.`
        );
        setOpenPermissionManagement(false);
        setIsEdited(false);
        // if (res.data.success === true) {
        //   setOpenPermissionManagement(true);
        //   setRolePermissionObj(res.data.data);
        // } else {
        //   // Handle error
        // }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
        // Handle error
      })
      .finally(() => {
        // Cleanup or loading state changes
        setIsLoading(false);
      });
  };

  const style1 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const handleConfirmationResponse = (confirm) => {
    if (changeCategoryModule) {
      if (confirm) {
        // let { value } = e.target;
        setAddSelectModule(changeCategoryModule);
        getRolePermissionData(selectedRoleId, `?moduleName=${changeCategoryModule}`);
      }
      setChangeCategoryModule(false);
    } else if (confirm) {
      setOpenPermissionManagement(false);
      setIsEdited(false);
    }
    setShowConfirmation(false);
  };

  const handleCategoryManagementClose = () => {
    if (isEdited) {
      setShowConfirmation(true);
    } else {
      setIsEdited(false);
      setOpenPermissionManagement(false);
      setOpenCreateProjectSuccessfully(false)
    }
  }



  return (
    <>
      <div className="login-forms">
        <div className="text-centers">
          <div class="heading_search_outer d sub-route-upper-sec">
            <div className="sub-route-sec">
              {configSubRoute.map(
                (ele, i) =>
                  ele.isSubRoute && (
                    <div
                      style={{ padding: "5px 7px 7px" }}
                      className={
                        location.pathname.indexOf(ele.path) !== -1
                          ? "sub-route-sec-div sub-route-sec-div-active"
                          : "sub-route-sec-div"
                      }
                    >
                      <Link to={ele.layout + ele.path}>{ele.name}</Link>
                      {/* <p>Existing Vendor</p> */}
                    </div>
                  )
              )}
            </div>
          </div>
          <div className="Role_lets_block_btn_addicon">
            {/* <button
              onClick={() => {
                setOpenPermissionManagement(true);
              }}
              className="role_btn_blocklist_addicon"
            >
              Role <AddIcon className="plus-btn" />
            </button> */}
          </div>

          <div>
            <div className="row">
              {blockList.map((ele, i) => (
                <>
                  <div className="col-sm-6">
                    <div className="category_box">
                      <div className="heading_plus">
                        <h3>{ele?.label}</h3>
                        <button className="plus-btn">
                          <AddIcon
                            onClick={() =>
                              handleAddModalOpen(true, ele, i, "Category")
                            }
                          />
                        </button>
                      </div>
                      <div className="cat-card-ui">
                        {ele?.list.length > 0 && (
                          <div>
                            {ele?.list?.map((item, j) => (
                              <div className="category_listing " key={item.id}>
                                <div className="array_react_list_name">
                                  {ele?.isInput && (
                                    <input
                                      type="checkbox"
                                      checked={item?.isChecked}
                                      onChange={(e) =>
                                        onCheckChange(
                                          e,
                                          blockList,
                                          ele,
                                          i,
                                          item,
                                          j,
                                          "Category"
                                        )
                                      }
                                    />
                                  )}
                                  <span>{item?.label}</span>
                                </div>
                                <DeleteIcon
                                  className="icon_color_electrical"
                                  onClick={(e) =>
                                    openDeleteModal(
                                      e,
                                      ele,
                                      i,
                                      item,
                                      j,
                                      ele?.blockName,
                                      "Category"
                                    )
                                  }
                                />
                              </div>
                            ))}
                          </div>
                        )}
                        {ele?.list.length < 1 && (
                          <div className="cat-card-nodata-ui">
                            <div>No Data Found</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              ))}
            </div>

            {/* For department and role */}

            <div className="row">
              {blockListDepart.map((ele, i) => (
                <>
                  <div className="col-sm-6">
                    <div className="category_box">
                      <div className="heading_plus">
                        <h3>{ele?.label}</h3>
                        <button className="plus-btn">
                          <AddIcon
                            onClick={() =>
                              handleAddModalOpen(true, ele, i, "Department")
                            }
                          />
                        </button>
                      </div>
                      <div className="cat-card-ui">
                        {ele?.list.length > 0 && (
                          <div>
                            {ele?.list?.map((item, j) => (
                              <div className="category_listing " key={item.id}>
                                <div className="array_react_list_name">
                                  {ele?.isInput && (
                                    <input
                                      type="checkbox"
                                      checked={item?.isChecked}
                                      onChange={(e) =>
                                        onCheckChange(
                                          e,
                                          blockList,
                                          ele,
                                          i,
                                          item,
                                          j,
                                          "Department"
                                        )
                                      }
                                    />
                                  )}
                                  <span>{item?.label}</span>
                                </div>
                                <div className="role-card-ico-list">
                                  {ele?.isUpdateRole == true && (
                                    <CreateIcon
                                      className="icon_color_electrical"
                                      onClick={(e) =>
                                        openUpdatePermissionModal(
                                          e,
                                          ele,
                                          i,
                                          item,
                                          j,
                                          ele?.blockName,
                                          "Department"
                                        )
                                      }
                                    />
                                  )}

                                  <DeleteIcon
                                    className="icon_color_electrical"
                                    onClick={(e) =>
                                      openDeleteModal(
                                        e,
                                        ele,
                                        i,
                                        item,
                                        j,
                                        ele?.blockName,
                                        "Department"
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                        {ele?.list.length < 1 && (
                          <div className="cat-card-nodata-ui">
                            <div>No Data Found</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              ))}
            </div>
          </div>
          {/* Permission Management Modal */}
          <Modal
            open={openpermissionmanagement}
            // onClose={() => setOpenPermissionManagement(false)}
            onClose={() => handleCategoryManagementClose(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={style}
              className="modal_react_controlpanel_employeese_management MuiBox-root css-1yw769x"
            >
              <div className="modal-header">
                <h5 className="modal-title permissionP_heading" id="exampleModalLabel">
                  Permission Management
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  // onClick={() => setOpenPermissionManagement(false)}
                  onClick={() => handleCategoryManagementClose(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div class="lets_vendor_lr_details_block_asnes">
                  <div class="required_react_vendor_block">
                    <label class="label_react_block_body_asn">Department</label>
                    <span class="required">*</span>
                    <div class="lets_asn_block_body_required_number">
                      <select
                        class="form-select vendor_lr_permission"
                        aria-label="Default select example"
                        fdprocessedid="a0s9sa"
                        value={addSelectValue}
                        disabled
                      >
                        {blockListDepart[0].list.map((departList, i) => (
                          <>
                            <option value={departList?._id}>
                              {departList?.label}
                            </option>
                          </>
                        ))}
                        {/* <option>Projects</option>
                        <option>Electrical</option>
                        <option>Civil</option>
                        <option>Mechanical</option>
                        <option>Instrumentation</option>
                        <option>Consultants</option>
                        <option>Architects</option>
                        <option>EPC</option>
                        <option>Constructions</option>
                        <option>IT Admin</option>
                        <option>Logistics</option>
                        <option>Others</option> */}
                      </select>
                    </div>
                  </div>
                  <div class="required_react_vendor_block">
                    <label class="label_react_block_body_asn">
                      Enter Role Name
                    </label>
                    <div class="lets_asn_block_body_required_number">
                      <input
                        type="text"
                        class="form-control vendor_lr_permission"
                        fdprocessedid="13mwf"
                        placeholder="Manager"
                        value={addTextValue}
                        disabled
                      />
                    </div>
                  </div>
                  <div class="required_react_vendor_block">
                    <label class="label_react_block_body_asn">
                      Select Module
                    </label>
                    <span class="required">*</span>
                    <div class="lets_asn_block_body_required_number">
                      <select
                        class="form-select vendor_lr_permission"
                        aria-label="Default select example"
                        fdprocessedid="a0s9sa"
                        onChange={changeModule}
                        value={addSelectModule}
                      >
                        <option value={"ONBOARDING"}>Onboarding Module</option>
                        <option value={"BIDDING"}>Bidding Module</option>
                        <option value={"P2P"}>P2P</option>
                        <option value={"CONTRACT_MANAGEMENT "}>Contract Management</option>
                        <option value={"VENDOR_EVALUATION_MODULE"}>Vendor Evaluation Module</option>
                        {/* <option>Bidding RFQ Module</option>
                        <option>PO to Receiving</option>
                        <option>Receiving to Payment</option>
                        <option>Finance</option>
                        <option>Dashboard & Reports</option>
                        <option>Architects</option>
                        <option>EPC</option>
                        <option>Constructions</option>
                        <option>IT Admin</option>
                        <option>Logistics</option>
                        <option>Others</option> */}
                      </select>
                    </div>
                  </div>
                </div>

                <DynamicNestedTable
                  data={rolePermissionObj}
                  handlePermissionToggle={handlePermissionToggle}
                />

                <div class="lets_vendor_lr_details_block_asne">
                  <table>
                    <thead>
                      <tr>
                        <th class="block_solars">Modules</th>
                        <th class="block_solars"></th>
                        <th class="block_solars"></th>
                        <th class="block_solars">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {roleAssignArr.length < 1 && (
                        <tr class="maine_tr_vendor">
                          <td colSpan={2} className="text-center">
                            {" "}
                            No Data Found
                          </td>
                        </tr>
                      )}

                      {roleAssignArr.length > 0 && (
                        <>
                          {roleAssignArr.map((ele) => (
                            <>
                              <tr class="maine_tr_vendor">
                                <td>{ele?.label}</td>
                                <td></td>
                                <td></td>
                                <td>{ele?.value}</td>
                              </tr>
                            </>
                          ))}
                        </>
                      )}
                      {/* <tr class="maine_tr_vendor">
                        <td>Bidding RFQ Module</td>
                        <td></td>
                        <td></td>
                        <td>Not Assigned</td>
                      </tr>
                      <tr class="maine_tr_vendor">
                        <td>PO to Receiving</td>
                        <td></td>
                        <td></td>
                        <td>Not Assigned</td>
                      </tr>
                      <tr class="maine_tr_vendor">
                        <td>Receiving to Payment</td>
                        <td></td>
                        <td></td>
                        <td>Not Assigned</td>
                      </tr>
                      <tr class="maine_tr_vendor">
                        <td>Finance</td>
                        <td></td>
                        <td></td>
                        <td>Not Assigned</td>
                      </tr>
                      <tr class="maine_tr_vendor">
                        <td>Dashboard & Reports</td>
                        <td></td>
                        <td></td>
                        <td>Not Assigned</td>
                      </tr> */}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="clear_btn_both_block_body_status">
                <button
                  type="button"
                  className="clear_btn_status_block_lists"
                  data-dismiss="modal"
                  fdprocessedid="0y9izm" onClick={handleClearToggles}
                >
                  Clear
                </button>
                <button
                  type="button"
                  className="btn btn-success save_next_btns"
                  fdprocessedid="ao4xc"
                  onClick={submitRolePermission}
                >
                  Submit
                </button>
              </div>
            </Box>
          </Modal>
          {/* Category Modal */}
          <Modal
            open={categoryOpen}
            onClose={() => setOpencategoryOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={style}
              className="modal_react_controlpanel_employee MuiBox-root css-1wnsr1i"
            >
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Add New Category
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setOpencategoryOpen(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="lets_select_smes">
                  <label className="mb-1 text-dark">
                    Enter Category Name <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="vendorName"
                    className="form-control form_h_modal"
                    placeholder="Enter Category Name"
                    required=""
                  />
                  <div className="error-message" id="vendorNameError"></div>
                </div>
              </div>
              <div className="clear_btn_status">
                <button
                  type="button"
                  className="btn clear_btn"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <Button
                  type="button"
                  className="btn btn-success save_next_btn"
                  onClick={() => {
                    setOpencategoryOpen(false);
                    setOpensuccessfullycategoryOpeneState(true);
                  }}
                >
                  Submit
                </Button>
              </div>
            </Box>
          </Modal>
          {/* Successfully Category Modal */}
          <Modal
            open={successfullycategoryOpen}
            onClose={() => setOpensuccessfullycategoryOpeneState(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={style}
              className="modal_react_controlpanel_employee MuiBox-root css-1wnsr1i"
            >
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel"></h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setOpensuccessfullycategoryOpeneState(false)}
                ></button>
              </div>
              <div className="modal-body_lets">
                <h5 className="modal-title" id="successModalLabel">
                  <img src={checkcircle} alt="" />
                  <p>Category has been created successfully!</p>
                </h5>
              </div>
            </Box>
          </Modal>
          {/* Sub-Category Modal */}
          <Modal
            open={subcategoryOpen}
            onClose={() => handleAddModalOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={style}
              className="modal_react_controlpanel_employee MuiBox-root css-1wnsr1i"
            >
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {addModalOpenData?.currentBlockName}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => handleAddModalOpen(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="">
                  <div className="row">
                    {addModalOpenData?.currentIdx > 0 &&
                      addModalOpenData?.secName == "Category" && (
                        <div className="col-sm-6">
                          <div className="lets_select_sme">
                            <label className="mb-1 text-dark">
                              {
                                blockList[addModalOpenData?.currentIdx - 1]
                                  .blockName
                              }{" "}
                              <span className="required">*</span>
                            </label>
                            <select
                              id="categorySelect"
                              className="form-select lets_sub_cotegory"
                              required=""
                              value={addSelectValue}
                              onChange={onAddSelectChange}
                            // defaultValue={blockList[addModalOpenData?.currentIdx-1].list[0]._id}
                            >
                              <option value={"null"} disabled={true}>
                                Please Select
                              </option>
                              {blockList[
                                addModalOpenData?.currentIdx - 1
                              ].list.map((optList, idx) => (
                                <>
                                  <option value={optList?._id}>
                                    {optList?.label}
                                  </option>
                                </>
                              ))}
                            </select>
                            <div
                              className="error-message"
                              id="categorySelectError"
                            ></div>
                          </div>
                        </div>
                      )}

                    {addModalOpenData?.currentIdx > 0 &&
                      addModalOpenData?.secName == "Department" && (
                        <div className="col-sm-6">
                          <div className="lets_select_sme">
                            <label className="mb-1 text-dark">
                              {
                                blockListDepart[
                                  addModalOpenData?.currentIdx - 1
                                ].blockName
                              }{" "}
                              <span className="required">*</span>
                            </label>
                            <select
                              id="categorySelect"
                              className="form-select lets_sub_cotegory"
                              required=""
                              value={addSelectValue}
                              onChange={onAddSelectChange}
                            // defaultValue={blockListDepart[addModalOpenData?.currentIdx-1].list[0]._id}
                            >
                              <option value={"null"} disabled={true}>
                                Please Select
                              </option>
                              {blockListDepart[
                                addModalOpenData?.currentIdx - 1
                              ].list.map((optList, idx) => (
                                <>
                                  <option value={optList?._id}>
                                    {optList?.label}
                                  </option>
                                </>
                              ))}
                            </select>
                            <div
                              className="error-message"
                              id="categorySelectError"
                            ></div>
                          </div>
                        </div>
                      )}

                    {addModalOpenData?.secName == "Category" && (
                      <div
                        className={
                          addModalOpenData?.currentIdx == 0
                            ? "col-sm-12"
                            : "col-sm-6"
                        }
                      >
                        <div className="">
                          <label className="mb-1 text-dark">
                            {blockList[addModalOpenData?.currentIdx]?.blockName}{" "}
                            <span className="required">*</span>
                          </label>
                          <input
                            type="text"
                            id="vendorName"
                            className="form-control form_h_modal"
                            placeholder={`Enter ${blockList[addModalOpenData?.currentIdx]?.blockName
                              }`}
                            value={addTextValue}
                            onChange={onAddTextChange}
                            required=""
                          />
                          <div
                            className="error-message"
                            id="vendorNameError"
                          ></div>
                        </div>
                      </div>
                    )}

                    {addModalOpenData?.secName == "Department" && (
                      <div
                        className={
                          addModalOpenData?.currentIdx == 0
                            ? "col-sm-12"
                            : "col-sm-6"
                        }
                      >
                        <div className="">
                          <label className="mb-1 text-dark">
                            {
                              blockListDepart[addModalOpenData?.currentIdx]
                                ?.blockName
                            }{" "}
                            <span className="required">*</span>
                          </label>
                          <input
                            type="text"
                            id="vendorName"
                            className="form-control form_h_modal"
                            placeholder={`Enter ${blockListDepart[addModalOpenData?.currentIdx]
                              ?.blockName
                              }`}
                            value={addTextValue}
                            onChange={onAddTextChange}
                            required=""
                          />
                          <div
                            className="error-message"
                            id="vendorNameError"
                          ></div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="clear_btn_status">
                <button
                  type="button"
                  className="btn clear_btn"
                  data-bs-dismiss="modal"
                  onClick={() => handleAddModalOpen(false)}
                >
                  Close
                </button>
                <Button
                  type="button"
                  className="btn btn-success save_next_btn"
                  onClick={addSubmit}
                >
                  Submit
                </Button>
              </div>
            </Box>
          </Modal>
          {/* Successfully Sub-Category Modal */}
          <Modal
            open={successfullysubcategoryOpen}
            onClose={() => setOpensuccessfullysubcategoryOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={style}
              className="modal_react_controlpanel_employee MuiBox-root css-1wnsr1i"
            >
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel"></h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setOpensuccessfullysubcategoryOpen(false)}
                ></button>
              </div>
              <div className="modal-body_lets">
                <h5 className="modal-title" id="successModalLabel">
                  <img src={checkcircle} alt="" />
                  <p>Sub-Category has been created successfully!</p>
                </h5>
              </div>
            </Box>
          </Modal>
          {/* Department Modal */}
          <Modal
            open={departmentsetopen}
            onClose={() => setdepartmentsetopen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={style}
              className="modal_react_controlpanel_employee MuiBox-root css-1wnsr1i"
            >
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Add New Departments
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setdepartmentsetopen(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="lets_select_smes">
                  <label className="mb-1 text-dark">
                    Enter Departments Name <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="departmentName"
                    className="form-control form_h_modal"
                    placeholder=" Enter Departments Name*"
                    required=""
                  />
                  <div className="error-message" id="departmentNameError"></div>
                </div>
              </div>
              <div className="clear_btn_status">
                <button
                  type="button"
                  className="btn clear_btn"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <Button
                  type="button"
                  className="btn btn-success save_next_btn"
                  onClick={() => {
                    setdepartmentsetopen(false);
                    setsuccessfullydepartmentsetopen(true);
                  }}
                >
                  Submit
                </Button>
              </div>
            </Box>
          </Modal>
          {/* Successfully Department Modal */}
          <Modal
            open={successfullydepartmentsetopen}
            onClose={() => setsuccessfullydepartmentsetopen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={style}
              className="modal_react_controlpanel_employee MuiBox-root css-1wnsr1i"
            >
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel"></h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setsuccessfullydepartmentsetopen(false)}
                ></button>
              </div>
              <div className="modal-body_lets">
                <h5 className="modal-title" id="successModalLabel">
                  <img src={checkcircle} alt="" />
                  <p>Sub-department has been created successfully!</p>
                </h5>
              </div>
            </Box>
          </Modal>
          {/* role Modal */}
          <Modal
            open={rolesetopen}
            onClose={() => setrolesetopen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={style}
              className="modal_react_controlpanel_employee MuiBox-root css-1wnsr1i"
            >
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Add New role
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setrolesetopen(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <div className="lets_select_sme">
                    <label className="mb-1 text-dark">
                      Department <span className="required">*</span>
                    </label>
                    <select
                      id="categorySelect"
                      className="form-select lets_sub_cotegory"
                      required=""
                    >
                      <option value="" disabled="" selected="">
                        Select
                      </option>
                      <option value="category1">Engineering</option>
                      <option value="category2">Quality</option>
                      <option value="category3">Projects</option>
                      <option value="category4">Strategy</option>
                      <option value="category5">EHS</option>
                      <option value="category6">IT</option>
                      <option value="category7">Admin</option>
                    </select>
                    <div
                      className="error-message"
                      id="categorySelectError"
                    ></div>
                  </div>
                  <div className="lets_select_sme">
                    <label className="mb-1 text-dark">
                      Enter Role Name <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="vendorName"
                      className="form-control form_h_modal"
                      placeholder="Enter Role Name"
                      required=""
                    />
                    <div className="error-message" id="vendorNameError"></div>
                  </div>
                </div>
              </div>
              <div className="clear_btn_status">
                <button
                  type="button"
                  className="btn clear_btn"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <Button
                  type="button"
                  className="btn btn-success save_next_btn"
                  onClick={() => {
                    setrolesetopen(false);
                  }}
                >
                  Submit
                </Button>
              </div>
            </Box>
          </Modal>
          {/* Delete Modal */}
          <Modal
            open={deleteiconopen}
            onClose={closeDeleteModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={style}
              className="modal_react_controlpanel_employee MuiBox-root css-1wnsr1i"
            >
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel"></h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={closeDeleteModal}
                ></button>
              </div>
              <div className="modal-body lets_list_cotegory_status_management_block_bodyP">
                <p className="lets_want_changes_delete_icon">
                  Do you really want to delete it?
                </p>

                <button
                  type="button"
                  className="btn clear_btn"
                  data-bs-dismiss="modal"
                  onClick={closeDeleteModal}
                >
                  Close
                </button>
                <Button
                  type="button"
                  className="btn btn-success save_next_btn"
                  onClick={confirmDeleteModal}
                >
                  Confirm
                </Button>
              </div>
            </Box>
          </Modal>
          {showConfirmation && (
            <Modal
              open={showConfirmation}
              onClose={() => handleConfirmationResponse(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => handleConfirmationResponse(false)}
                  ></button>
                </div>
                <div className="modal-bodys">
                  {changeCategoryModule ? <p>You have unsaved changes. Are you sure you want to Change?</p> : <p>You have unsaved changes. Are you sure you want to close?</p>}
                  <button className=" btn btn-warning" onClick={() => handleConfirmationResponse(false)}>No</button>
                  <button className="btn btn-success mr-7" onClick={() => handleConfirmationResponse(true)}>Yes</button>
                </div>
              </Box>
            </Modal>
          )}
        </div>
      </div>

      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleClose}
      />
      <Backdrop
        className="backdrop-index"
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default CategoryManagement;
